import { render, staticRenderFns } from "./ExpensePeriodMember.vue?vue&type=template&id=3cd20a10"
import script from "./ExpensePeriodMember.vue?vue&type=script&lang=js"
export * from "./ExpensePeriodMember.vue?vue&type=script&lang=js"
import style0 from "./ExpensePeriodMember.vue?vue&type=style&index=0&id=3cd20a10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports